import React, { useEffect, useState } from "react";
import { toast } from "react-toastify";
import { useApi } from "../../../../hooks/useApi";
import Loader from "../../../DefaultStyles/Loader";
import { Textarea } from "../../../Input/Textarea";
import AlertModal from "../../../Modal/AlertModal";
import DefaultModalLayout from "../../../Modal/DefaultModalLayout";
import { DeleteModalLabel } from "../../Users/UserDetail/CommentModal/CommentDeleteModal";

interface PayExecuteModalProps {
  closeEvent: () => void;
  executeData: {
    user: string;
    id: string;
  };
  successEvent: () => void;
}

export default function PayExecuteModal({
  closeEvent,
  executeData,
  successEvent,
}: PayExecuteModalProps) {
  const [reason, setReason] = useState("");
  const [execute, setExecute] = useState(false);
  const [errorString, setErrorString] = useState("");
  const [errorModal, setErrorModal] = useState(false);
  const [checkAlert, setCheckAlert] = useState(false);

  const { response, error, loading } = useApi({
    method: "post",
    url: execute ? `pay/immetate` : undefined,
    data: {
      id: executeData?.id ?? "",
      reason,
    },
  });

  console.log(response);
  console.log(error);

  useEffect(() => {
    if (response?.status === 201 || response?.status === 200) {
      closeEvent();
      toast.success("예약 결제가 실행되었습니다.");
      successEvent();
    }
  }, [response]);

  useEffect(() => {
    if (error) {
      setErrorString(`${error.data}`);
      setErrorModal(true);
    }
  }, [error]);

  return (
    <>
      <DefaultModalLayout
        modalTitle="예약 결제 즉시 실행"
        confirmEvent={() => setCheckAlert(true)}
        closeEvent={closeEvent}
        isDeleteModal={true}
        isSmallModal={true}
        confirmBtnText="계속"
        confirmDisabled={reason === ""}
      >
        <DeleteModalLabel>결제 사유</DeleteModalLabel>

        <Textarea
          placeholder="결제 사유 입력(100글자 이내)"
          onChange={(e) => setReason(e.target.value)}
          value={reason}
          maxLength={100}
        />
      </DefaultModalLayout>

      {checkAlert && (
        <AlertModal
          title={`${executeData?.user}님의 예약 결제가 즉시 실행됩니다.\n계속하시겠습니까?`}
          confirmEvent={() => {
            setExecute(true);
            setCheckAlert(false);
          }}
          cancelEvent={() => setCheckAlert(false)}
        />
      )}

      {errorModal && (
        <AlertModal
          title={errorString}
          customCancelBtn={<></>}
          confirmEvent={() => {
            setErrorModal(false);
            setExecute(false);
          }}
        />
      )}

      {loading && <Loader />}
    </>
  );
}
